<!-- https://8es9hr.axshare.com/#g=1&p=%E6%AA%A2%E8%A6%96%E5%8A%A0%E9%80%80%E4%BF%9D%E7%94%B3%E8%AB%8B%E5%90%8D%E5%86%8A -->
<!-- 儲互社加退保申請名冊管理
     儲互社加保申請通過名單管理
     儲互社加保申請不通過名單管理
     儲互社加保申請補件名單管理
     儲互社退保申請名冊管理  -->
<template>
  <div class="row">
    <div class="col-12">
      <div class="col-block">
        <div class="block-header has-border">
          <h3>
            <strong>
              {{
                $route.query.type == "quit"
                  ? "退保作業"
                  : $route.query.type == "modify"
                  ? "資料變更作業"
                  : "加保作業"
              }}
            </strong>
            申請序號 : {{ recordToEdit.code }}
          </h3>
        </div>
        <div class="block-content">
          <el-tabs type="border-card">
            <el-tab-pane label="基本資料">
              <el-form label-position="top">
                <el-form-item label="申請方案">
                  <el-select
                    v-model="recordToEdit.insPlanYearId"
                    :disabled="true"
                    placeholder="請選擇"
                  >
                    <el-option
                      v-for="(item, index) in yearData"
                      :key="index"
                      :label="item.year - 1911"
                      :value="item.id"
                    ></el-option>
                  </el-select>
                  <el-select
                    v-model="recordToEdit.insPlanSubId"
                    placeholder="請選擇"
                    class="ml10"
                    :disabled="true"
                  >
                    <el-option
                      v-for="(item, index) in subData"
                      :key="index"
                      :label="item.name"
                      :value="item.id"
                    ></el-option>
                  </el-select>
                  <br />
                  <h3 v-if="$route.query.type != 'quit'">
                    <b>互助費 : {{ subFee }}</b>
                  </h3>

                  <h3 v-if="$route.query.type == 'quit'">
                    已繳互助費 : {{ payFee }}
                  </h3>
                  <br v-if="$route.query.type == 'quit'" />
                  <h3 v-if="$route.query.type == 'quit'">
                    應退互助費 :
                    {{ recordToEdit.backAmount }}
                  </h3>
                </el-form-item>

                <!--  <el-form-item label="輸入申請人帳號" >
                                    <el-input v-model="input" placeholder="請輸入內容" style="width: 200px;"></el-input>
                                    <el-button type="primary" plain class="ml10">確認</el-button>
                                    <el-button type="danger" plain>重新輸入</el-button>
                                </el-form-item>-->
                <el-form-item label="申請人資料">
                  <!-- <el-button plain>開啟申請人個人資訊</el-button> -->
                  <span style="color: red" class="ml10">
                    {{ member.applyTypeStr }}
                  </span>
                  <table class="table table-bordered mb-0 mt10 info">
                    <tbody>
                      <tr>
                        <td>社號</td>
                        <td>{{ member.coopCode }}</td>
                      </tr>
                      <tr>
                        <td>帳號</td>
                        <td>{{ member.account }}</td>
                      </tr>
                      <tr>
                        <td>姓名</td>
                        <td>{{ member.name }}</td>
                      </tr>
                      <tr>
                        <td>性別</td>
                        <td>{{ genderData[member.sex] }}</td>
                      </tr>
                      <tr>
                        <td>證件號碼 (身分證/居留證等)</td>
                        <td>{{ member.idNumber }}</td>
                      </tr>
                      <tr>
                        <td>出生年月</td>
                        <td>{{ $transferDate(member.birthday) }}</td>
                      </tr>
                      <tr>
                        <td>職業</td>
                        <td>{{ member.job }}</td>
                      </tr>
                      <tr>
                        <td>職稱</td>
                        <td>{{ member.jobTitle }}</td>
                      </tr>
                      <tr v-if="$route.query.type == 'modify'">
                        <td>申請變更項目</td>
                        <td>
                          <el-checkbox-group
                            v-model="recordToEdit.applyChangeItems.changeType"
                          >
                            <el-checkbox
                              :disabled="true"
                              v-for="(change, index) in changeType"
                              :key="index"
                              :label="change.value"
                            >
                              {{ change.label }}
                              <el-input
                                :disabled="true"
                                v-if="change.label === '其他'"
                                class="mt10 mb10"
                                v-model="
                                  recordToEdit.applyChangeItems.otherValue
                                "
                              ></el-input>
                            </el-checkbox>
                          </el-checkbox-group>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </el-form-item>

                <el-form-item
                  label="受益人分配方式"
                  v-if="$route.query.type != 'quit'"
                >
                  <el-radio-group
                    v-model="recordToEdit.bnfType"
                    :disabled="true"
                  >
                    <el-radio
                      v-for="(item, index) in bnf"
                      :key="index"
                      :label="item.value"
                      >{{ item.label }}</el-radio
                    >
                  </el-radio-group>
                </el-form-item>
                <el-form-item
                  label="獎勵或補助/其他扣除金額"
                  v-if="
                    $route.query.type != 'quit' && $route.query.type != 'modify'
                  "
                >
                  <el-input
                    :disabled="true"
                    v-model="recordToEdit.subsidyAmount"
                    placeholder="請輸入金額"
                    style="width: 220px"
                  >
                    <template slot="prepend">NT $</template>
                  </el-input>
                </el-form-item>
                <el-form-item
                  label="相關傳票"
                  v-if="
                    $route.query.type != 'quit' && $route.query.type != 'modify'
                  "
                >
                  <div class="date">
                    <input
                      type="text"
                      class="min_go_date subsidyVoucherDate1 subsidyVoucherDate"
                      placeholder="選擇日期"
                      :disabled="true"
                    />
                    <span class="el-input__prefix">
                      <i class="el-icon-date"></i>
                    </span>
                  </div>
                  <el-input
                    v-model="recordToEdit.subsidyVoucherCode"
                    class="ml10"
                    placeholder="請輸入傳票號碼"
                    style="width: 200px"
                    :disabled="true"
                  ></el-input>
                </el-form-item>
                <el-form-item label="申請日期">
                  {{
                    recordToEdit.sendGenDate == undefined
                      ? ""
                      : $transferDate(recordToEdit.sendGenDate)
                  }}
                </el-form-item>
                <el-form-item label="生效日期">
                  {{
                    recordToEdit.insEffectiveDate == undefined
                      ? ""
                      : $transferDate(recordToEdit.insEffectiveDate)
                  }}
                </el-form-item>
                <el-form-item label="協會送件日期">
                  <div class="date">
                    <input
                      type="text"
                      class="min_go_date genSendDate1 genSendDate"
                      placeholder="選擇日期"
                    />
                    <span class="el-input__prefix">
                      <i class="el-icon-date"></i>
                    </span>
                  </div>
                </el-form-item>
                <el-form-item label="協會送件郵局存根條碼">
                  <el-input
                    v-model="recordToEdit.genSendCode"
                    style="width: 220px"
                  ></el-input>
                </el-form-item>

                <el-form-item label="保單號碼">
                  <el-input
                    v-model="recordToEdit.policyNumber"
                    style="width: 220px"
                  ></el-input>
                </el-form-item>

                <el-form-item label="投保編號">
                  <el-input
                    v-model="recordToEdit.insuranceCode"
                    style="width: 220px"
                  ></el-input>
                </el-form-item>

                <el-form-item :label="underwriteStatusLabel">
                  <el-radio-group v-model="recordToEdit.underwriteStatus">
                    <el-radio
                      v-for="(underwrite, index) in underwriteStatus"
                      :key="index"
                      :label="underwrite.value"
                      >{{ underwrite.label }}</el-radio
                    >
                  </el-radio-group>
                </el-form-item>
                <!--underwriteStatus == 通過(1)-->
                <el-form-item
                  label="保險卡狀態"
                  v-if="recordToEdit.underwriteStatus == 1"
                >
                  <el-radio-group v-model="recordToEdit.insCardSendStatus">
                    <el-radio
                      v-for="(cardSend, index) in cardSendStatus"
                      :key="index"
                      :label="cardSend.value"
                      :disabled="true"
                      >{{ cardSend.label }}</el-radio
                    >
                  </el-radio-group>
                </el-form-item>
                <!--underwriteStatus == 不通過(2) || underwriteStatus == 退保通過(3)-->
                <el-form-item
                  label="退費狀態"
                  v-if="
                    recordToEdit.underwriteStatus == 2 ||
                    recordToEdit.underwriteStatus == 3
                  "
                >
                  <el-radio-group v-model="recordToEdit.refoundStatus">
                    <el-radio
                      v-for="(refound, index) in refoundStatus"
                      :key="index"
                      :label="refound.value"
                      >{{ refound.label }}</el-radio
                    >
                  </el-radio-group>
                </el-form-item>
                <!--如果退費狀態是以退費-->
                <el-form-item
                  label="退費金額"
                  v-if="recordToEdit.refoundStatus === 1"
                >
                  <el-input
                    v-model="recordToEdit.realBackAmount"
                    class="ml10"
                    placeholder="請輸入退費金額"
                    style="width: 200px"
                  ></el-input>
                </el-form-item>
                <el-form-item
                  label="保險卡寄送日期"
                  v-show="recordToEdit.underwriteStatus == 1"
                >
                  <div class="date">
                    <input
                      type="text"
                      class="min_go_date insCardSendDate1 insCardSendDate"
                      placeholder="選擇日期"
                    />
                    <span class="el-input__prefix">
                      <i class="el-icon-date"></i>
                    </span>
                  </div>
                </el-form-item>

                <el-form-item
                  label="保險公司實收保費"
                  v-show="recordToEdit.underwriteStatus == 1"
                >
                  <el-input
                    v-model="recordToEdit.realPremium"
                    v-on:input="
                      resetAmount(recordToEdit.realPremium, 'realPremium')
                    "
                    class="ml10"
                    style="width: 200px"
                  ></el-input>
                </el-form-item>

                <el-form-item label="保險公司狀態文字">
                  <el-input
                    v-model="recordToEdit.insurerStatus"
                    style="width: 220px"
                  ></el-input>
                </el-form-item>

                <el-form-item label="補件狀態">
                  <el-radio-group v-model="recordToEdit.needAddDoc">
                    <el-radio
                      v-for="(addDoc, index) in addDocStatus"
                      :key="index"
                      :label="addDoc.value"
                      >{{ addDoc.label }}</el-radio
                    >
                  </el-radio-group>
                </el-form-item>

                <el-form-item>
                  <el-button type="primary" @click="openDialog" plain
                    >建立補件通知</el-button
                  >
                </el-form-item>

                <!-- 補件通知Dialog -->
                <el-dialog
                  title="補件通知"
                  :visible.sync="dialogAddDoc"
                  :modal-append-to-body="false"
                  :append-to-body="true"
                >
                  <el-form ref="ruleForm">
                    <el-form-item>
                      <el-input
                        v-model="noticeData"
                        class="mt10"
                        type="textarea"
                        :rows="4"
                      ></el-input>
                      <el-button
                        type="primary"
                        class="mt10"
                        @click="sendAddDocNotice"
                        plain
                        >發送補件通知</el-button
                      >
                    </el-form-item>
                    <el-form-item label="歷史紀錄">
                      <workbench
                        api="InsPlanMemberApply"
                        :query="queryHistory"
                        :columns="columns2"
                        :toolbar="toolbarHistory"
                        ref="queryHistory"
                      ></workbench>
                    </el-form-item>
                  </el-form>
                </el-dialog>

                <!-- needAddDoc == 已補件(2)
                                <el-form-item label="補件日期"
                                              v-show="recordToEdit.needAddDoc == 2">
                                    <div class="date">
                                        <input type="text"
                                               class="min_go_date addDocDate1 addDocDate"
                                               placeholder="選擇日期">
                                        <span class="el-input__prefix">
                                            <i class="el-icon-date"></i>
                                        </span>
                                    </div>
                                </el-form-item>
                                <el-form-item label="補件說明"
                                              v-if="$route.query.type != 'quit'">
                                    <el-input v-model="recordToEdit.addDocReason"
                                              class="ml10"
                                              placeholder="請輸入補件說明"
                                              style="width: 200px;"></el-input>
                                </el-form-item>-->
              </el-form>
              <el-button type="primary" @click="saveMainEdit">儲存</el-button>
              <el-button @click="back">取消</el-button>
            </el-tab-pane>
            <el-tab-pane label="受益人資料" v-if="$route.query.type != 'quit'">
              <workbench
                api="InsPlanMemberApplyBnf"
                :query="query"
                :columns="columns[recordToEdit.bnfType == 0 ? 0 : 1]"
                :toolbar="toolbar"
                @editData="editData"
                @addData="editData"
                @enumData="getBnfEnumData"
              ></workbench>
            </el-tab-pane>
          </el-tabs>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { API } from "@/assets/config";
import Workbench from "@/components/Workbench";

export default {
  name: "agency_coopplusroster_edit",
  components: {
    Workbench,
  },

  data() {
    return {
      id: this.$route.params.subId,
      api: "",
      subFee: 0,
      payFee: 0,

      query: {
        insPlanMemberApplyId:
          this.$route.params.subId === "new" ? 0 : this.$route.params.subId,
      },

      setTimeKey: [
        "insEffectiveDate",
        "genSendDate",
        "subsidyVoucherDate",
        "employeeEndDate",
        "employeeStartDate",
        "insCardSendDate",
        "addDocDate",
      ],
      recordToEdit: { realBackAmount: "", bnfType: 1 },
      toolbar: {
        addable: false,
        removeable: false,
      },
      genderData: {},
      addDocStatus: {},
      cardSendStatus: {},
      refoundStatus: {},
      underwriteStatus: {},
      changeType: {},
      underwriteStatusLabel: "",
      yearData: {},
      bnf: {},
      subData: {},
      member: {},
      bnfDataList: [],
      columns: [
        [
          {
            label: "順位",
            prop: "bnfSeq",
          },
          {
            label: "身分證字號",
            prop: "idNumber",
          },
          {
            label: "姓名",
            prop: "name",
          },
          {
            label: "關係",
            prop: "relation",
            renderFunction(h, scope, enumData) {
							return h("div", this.$getBnfRelationText(scope.row, enumData.insBnfRelation));
						},
          },
          {
            label: "電話",
            prop: "phone",
          },
          {
            label: "住址",
            prop: "addr",
          },
          {
            prop: "updateTime",
            label: "最後修改",
          },
          {
            prop: "updateUserName",
            label: "最後修改人員",
          },
        ],
        [
          {
            label: "身分證字號",
            prop: "idNumber",
          },
          {
            label: "姓名",
            prop: "name",
          },
          {
            label: "關係",
            prop: "relation",
            renderFunction(h, scope, enumData) {
							return h("div", this.$getBnfRelationText(scope.row, enumData.insBnfRelation));
						},
          },
          {
            label: "電話",
            prop: "phone",
          },
          {
            label: "住址",
            prop: "addr",
          },
          {
            prop: "updateTime",
            label: "最後修改",
          },
          {
            prop: "updateUserName",
            label: "最後修改人員",
          },
        ],
      ],
      dialogListForm: false,
      currentEdit: {},
      // 補件通知
      dialogAddDoc: false,
      noticeData: "",
      queryHistory: {
        action: "getNoticeHistoryList",
        sourceId:
          this.$route.params.subId === "new" ? 0 : this.$route.params.subId,
        type: this.$route.query.type,
      },
      toolbarHistory: {
        allClose: true,
        search: false,
        select: false,
        editable: false,
      },
      columns2: [
        {
          label: "發送時間",
          prop: "updateTime",
        },
        {
          label: "通知人",
          prop: "updateUserName",
        },
        {
          label: "社業務負責人",
          prop: "ownerUserName",
        },
        {
          label: "已讀/未讀",
          prop: "viewed",
          renderFunction(h, scope, enumData) {
            return h("div", enumData.readKind[scope.row.viewed]);
          },
        },
        {
          prop: "",
          label: "內容",
          renderFunction: (h, scope, enumData) => {
            return h(
              "div",
              {
                style: {
                  "text-align": "center",
                },
              },
              [
                h(
                  "el-button",
                  {
                    props: {
                      type: "primary",
                      plain: true,
                    },
                    on: {
                      click: () => {
                        this.showNoticeData(scope.row.noticeData);
                        // this.transferData(scope.row);
                      },
                    },
                  },
                  "檢視"
                ),
              ]
            );
          },
          width: "150",
        },
        {
          label: "email狀態",
          prop: "emailStatus",
          renderFunction(h, scope, enumData) {
            return h("div", enumData.scheduleTask[scope.row.emailStatus]);
          },
        },
        {
          label: "sms狀態",
          prop: "smsStatus",
          renderFunction(h, scope, enumData) {
            return h("div", enumData.scheduleTask[scope.row.smsStatus]);
          },
        },
      ],
    };
  },
  created() {
    if (this.id != "new") {
      this.getData();
    }
  },
  mounted() {
    const vm = this;
    $(".min_go_date").datepicker({
      changeYear: true,
      changeMonth: true,
      currentText: "今天",
      dateFormat: "Rmmdd",
      showButtonPanel: true,
      yearRange: "1912:c+10",
      onSelect(data) {
        let key = $(this)[0].className.split(" ")[2];
        if (data) {
          vm.recordToEdit[key] =
            parseInt(data.split("-")[0]) + 1911 + "-" + data.slice(4);
        }
      },
    });
  },
  watch: {
    recordToEdit: {
      handler: function () {
        if (this.recordToEdit.underwriteStatus != 1) {
          this.recordToEdit.insCardSendStatus = 0;
        }
        if (
          this.recordToEdit.underwriteStatus != 2 &&
          this.recordToEdit.underwriteStatus != 3
        ) {
          this.recordToEdit.refoundStatus = 0;
        }

        if (this.recordToEdit.refoundStatus == 0) {
          this.recordToEdit.realBackAmount = "";
        }
      },
      deep: true,
    },
    "recordToEdit.insPlanSubId": function () {
      let pos = this.subData.findIndex(
        (sub) => sub.id === this.recordToEdit.insPlanSubId
      );
      this.subFee = pos === -1 ? 0 : this.subData[pos].premium;
    },
  },
  methods: {
    //受益人關係選單
    getBnfEnumData(item) {
      this.bnfDataList = Object.keys(item.insBnfRelation).map((items) => {
        return {
          label: item.insBnfRelation[items],
          value: Number(items),
        };
      });
    },
    getData() {
      const url =
        API.InsPlanMemberApply +
        `?id=${this.id}&insPlanMainCode=${this.$route.params.code}`;
      const thenCB = (json) => {
        this.recordToEdit = Object.assign(
          {},
          this.recordToEdit,
          json.resultData.data
        );
        this.recordToEdit.applyChangeItems = json.resultData.data
          .applyChangeItemObject || {
          changeType: [],
          otherValue: "",
        };
        this.renderAgent(json.resultData.enumData, json.resultData.data);
        setTimeout(() => {
          this.setTimeKey.forEach((item) => {
            if (json.resultData.data[item]) {
              $(`.${item}`).val(
                `${
                  parseInt(json.resultData.data[item]) - 1911 < 100
                    ? `0${parseInt(json.resultData.data[item]) - 1911}${
                        json.resultData.data[item].slice(4).split(" ")[0]
                      }`
                    : `${parseInt(json.resultData.data[item]) - 1911}${
                        json.resultData.data[item].slice(4).split(" ")[0]
                      }` || ""
                }`
              );
            }
          });
        }, 1);
      };
      this.mAxiosGet(url, thenCB);
    },
    renderAgent(enumData, resultData) {
      let underwriteStatusSelection = {};

      switch (this.$route.query.type) {
        case "quit":
          this.underwriteStatusLabel = "退保狀態";
          underwriteStatusSelection = enumData.insPlanUnderwriteStatusBack;
          break;
        case "modify":
          this.underwriteStatusLabel = "資料變更狀態";
          underwriteStatusSelection = enumData.insPlanUnderwriteStatusModify;
          break;
        default:
          this.underwriteStatusLabel = "核保狀態";
          underwriteStatusSelection = enumData.insPlanUnderwriteStatusAdd;
          break;
      }
      this.payFee =
        enumData.payment === undefined ||
        enumData.payment.payAmount == undefined
          ? 0
          : enumData.payment.payAmount;
      // 受益人分配方式額外處理
      let arr = [];
      Object.keys(enumData.bnfType).map((key) => {
        arr.push({
          label: enumData.bnfType[key],
          value: parseInt(key),
        });
      });
      this.bnf = arr.reverse();
      this.addDocStatus = this.renderSelection(
        enumData.insPlanApplyAddDocStatus
      );
      this.cardSendStatus = this.renderSelection(
        enumData.insPlanApplyCardSendStatus
      );
      this.refoundStatus = this.renderSelection(
        enumData.insPlanApplyRefoundStatus
      );
      this.underwriteStatus = this.renderSelection(underwriteStatusSelection);
      this.yearData = enumData.insPlanYear;
      this.subData = enumData.insPlanSub;
      this.genderData = enumData.gender;

      this.changeType = Object.keys(enumData.insPlanApplyChangeType).map(
        (change) => {
          return {
            label: enumData.insPlanApplyChangeType[change],
            value: parseInt(change),
          };
        }
      );

      this.member = {
        coopCode: enumData.memberInfo.coopCode,
        account: enumData.memberInfo.account,
        name: resultData.name,
        sex: resultData.sex,
        idNumber: resultData.idNumber,
        birthday: resultData.birthday,
        job: resultData.job,
        jobTitle: resultData.title,
      };
    },
    renderSelection(enumSelection) {
      return Object.keys(enumSelection).map((key) => {
        return { label: enumSelection[key], value: parseInt(key) };
      });
    },
    editData(id, row) {
      // edit
      this.currentEdit = {};
      this.dialogListForm = true;
      if (id !== "new") {
        this.currentEdit = Object.assign({}, this.currentEdit, row);
      }
    },

    saveMainEdit() {
      let url = API.InsPlanMemberApply + `?action=update`;
      const form = new FormData();

      form.append("id", this.id);
      if (this.recordToEdit.insEffectiveDate !== undefined) {
        form.append("insEffectiveDate", this.recordToEdit.insEffectiveDate);
      }
      if (this.recordToEdit.genSendDate !== undefined) {
        form.append("genSendDate", this.recordToEdit.genSendDate);
      }
      form.append("genSendCode", this.recordToEdit.genSendCode || "");

      form.append(
        "underwriteStatus",
        this.recordToEdit.underwriteStatus || "0"
      );
      form.append(
        "insCardSendStatus",
        this.recordToEdit.insCardSendStatus || "0"
      );
      form.append("refoundStatus", this.recordToEdit.refoundStatus || "0");
      form.append("insCardSendDate", this.recordToEdit.insCardSendDate || "");

      form.append("needAddDoc", this.recordToEdit.needAddDoc || "");

      if (this.recordToEdit.addDocDate !== undefined) {
        form.append("addDocDate", this.recordToEdit.addDocDate);
      }

      form.append("addDocReason", this.recordToEdit.addDocReason || "");
      form.append("realBackAmount", this.recordToEdit.realBackAmount || "");
      form.append("realPremium", this.recordToEdit.realPremium || 0);

      let thenCB = (json) => {
        this.showAjaxSuccessMsg();
        this.getData();
      };

      this.mAxiosPost(url, form, thenCB);
    },

    saveDialogEdit() {
      // var url = API.InsPlanYear

      // const form = new FormData();
      // if (this.currentEdit.id !== 'new' && this.currentEdit.id !== 0 && this.currentEdit.id) {
      //     form.append('id', this.currentEdit.id);
      //     url += `?action=update`;
      // } else {
      //     url += `?action=append`;
      // }

      // form.append('year', this.currentEdit.year !== undefined ? this.currentEdit.year : '');
      // form.append('periodStart', this.currentEdit.periodStart !== undefined ? this.currentEdit.periodStart : '');
      // form.append('periodEnd', this.currentEdit.periodEnd !== undefined ? this.currentEdit.periodEnd : '');
      // form.append('applicationStart', this.currentEdit.applicationStart !== undefined ? this.currentEdit.applicationStart : '');
      // form.append('applicationEnd', this.currentEdit.applicationEnd !== undefined ? this.currentEdit.applicationEnd : '');

      // let thenCB = json => {
      //     this.showAjaxSuccessMsg();
      //     this.$refs.workbench.getData();
      // }
      // this.mAxiosPost(url, form, thenCB);
      this.dialogListForm = false;
    },
    back() {
      this.$router.push({
        name: "agency_coopplusroster",
        query: {
          type: this.$route.query.type,
        },
      });
    },
    openDialog() {
      this.dialogAddDoc = true;
    },
    sendAddDocNotice() {
      var url = API.InsPlanMemberApply;

      if (!this.noticeData) {
        this.$message.error("請輸入補件通知");
        return;
      }

      const form = new FormData();
      if (
        this.query.insPlanMemberApplyId !== 0 &&
        this.query.insPlanMemberApplyId
      ) {
        form.append("sourceId", this.query.insPlanMemberApplyId);
        form.append("type", this.$route.query.type);
        url += `?action=createAddDocNotice`;
      }

      form.append("noticeData", this.noticeData);

      let thenCB = (json) => {
        this.showAjaxSuccessMsg();
        this.noticeData = "";
        this.$refs.queryHistory.getData();
      };
      this.mAxiosPost(url, form, thenCB);
    },
    showNoticeData(msg) {
      this.$confirm(msg, "", {
        showClose: false,
        cancelButtonText: "關閉",
        cancelButtonClass: "el-button--danger is-plain",
        showConfirmButton: false,
        center: true,
      });
    },
    resetAmount(amount, key) {
      return (this.recordToEdit[key] = this.$addcomma(
        this.$removeComma(amount)
      ));
    },
  },
};
</script>
<style lang="scss">
table.info td {
  padding-top: 0;
  padding-bottom: 0;
}
.disblock {
  display: block;
  position: relative;
  .el-input__suffix {
    top: 30%;
  }
}
</style>